import React, { useContext, useState, Suspense } from "react";
import LoadingBar from "react-top-loading-bar";
import { Routes, Route, Outlet } from "react-router-dom";
import ScrollToTop from "components/navigation/scroll_to_top";

import ScoraCart from "pages/cart/scora";
import ScoraCheckout from "pages/cart/checkout";
import ScoraOrderConfirmed from "pages/cart/orderConfirmed";
import ScoraProduct from "pages/products/scora";

import ScoraHeader from "components/headers/scora";
import ScoraFooter from "components/footers/scora";


export default function Index(props) {
  // Switch product page based on URL
  const url = new URL(window.location.href);
  const pathComponents = url.pathname.split("/");

  // Header view stored in /components/headers/companyname
  const getHeaderView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraHeader {...props} />
    }
  }

  // Product view stored in /pages/products/companyname
  const getProductView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraProduct {...props} />
    }
  }

  // Cart view stored in /pages/cart/companyname
  const getCartView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraCart {...props} />
    }
  }

  const getCheckoutView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraCheckout {...props} />
    }
  }

  const getOrderConfirmedView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraOrderConfirmed {...props} />
    }
  }

  // Header view stored in /components/footers/companyname
  const getFooterView = () => {
    switch (pathComponents[1]) {
      case "scora":
        return <ScoraFooter {...props} />
    }
  }  

  const routes = [
    { url: "/scora", component: getProductView(pathComponents) },
    { url: "/scora/cart", component: getCartView(pathComponents) },
    { url: "/scora/checkout", component: getCheckoutView(pathComponents) },
    { url: "/scora/orderConfirmed", component: getOrderConfirmedView(pathComponents) },
  ];

  return (
    <>
      <LoadingBar height={3} color="#28a745" progress={100} />
      {
        getHeaderView()
      }
      
      <div className="d-flex" style={{ overflowX: "hidden" }}>
        <Routes>
          {routes.map((data, i) => (
            <Route
              key={`${data.url}`}
              exact
              path={data.url}
              element={data.component}
            />
          ))}
        </Routes>
      </div>
      <ScrollToTop />
      {
        getFooterView()
      }
    </>
  );
};

